import axios from 'axios';
import RequestWrapper from '.';
import { CreateGroupBuy } from '../config/interfaces';

export const fetchSettings = () => {
	return RequestWrapper(axios.get('/businesses/groupbuysetup'));
};

export const fetchStripeClientSecret = () => {
	return RequestWrapper(axios.get('/payments'));
};
export const createGroupBuy = (data: CreateGroupBuy) => {
	return RequestWrapper(axios.post('/transactions/groupbuy', data));
};

export const trackGroupBuy = (id: string) => {
	return RequestWrapper(axios.get(`/transactions/groupbuyTracking/${id}`));
};

export const validateTransaction = (sessionId: string) => {
	return RequestWrapper(axios.get(`/transactions/validate-payment/${sessionId}`));
};
